import { html } from 'lit-element';
import { optoutProduct } from '../core/actions';
import { OptinStatus, mapStateToProps } from './OptinStatus';
import { connect } from '../core/connect';

export class OptoutButton extends OptinStatus {
  static get properties() {
    return {
      ...super.properties,
      label: { type: String }
    };
  }

  handleClick(ev) {
    this.optoutProduct(this.product, this.offer);
    ev.preventDefault();
  }

  render() {
    return html`
      <slot name="default">
        <button
          aria-labelledby="ogOfferOptOutLabel"
          role="radio"
          aria-checked="${!this.subscribed}"
          class="btn radio ${this.subscribed ? '' : 'active'}"
        ></button>
        <label id="ogOfferOptOutLabel">
          <slot>
            <og-text key="offerOptOutLabel"></og-text>
          </slot>
        </label>
      </slot>
    `;
  }
}

export const ConnectedOptoutButton = connect(mapStateToProps, { optoutProduct })(OptoutButton);

export default ConnectedOptoutButton;
